import AppCatalog from "../../services/App/AppCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Name: {
    Label: AppCatalog.Field.Name.Label,
    Type: AppCatalog.Field.Name.Type,
    ReadOnly: true
  },
  SelfServicePin: {
    Label: AppCatalog.Field.Pin.Label,
    Type: AppCatalog.Field.Pin.Type,
    Required: true
  }
}